import { styled } from "@mui/material";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";

export const StyledToggleViewButtons = styled(ToggleButtonGroup)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  columnGap: "4px",
  height: "32px",
  padding: "4px",
  border: `1px solid ${theme.colors["botticelli-blue"]}`,
  boxShadow: "0px 0.5px 1px rgba(0, 0, 0, 0.12)",
  borderRadius: "3px",

  "& > .MuiToggleButton-root.Mui-selected": {
    backgroundColor: theme.colors["blue-ribbon"],
    borderRadius: "3px",
    color: theme.colors.white,
  },
  "& > .MuiToggleButton-root.Mui-selected:hover": {
    backgroundColor: theme.colors["banner-blue"],
  },
}));

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  border: "transparent",
  height: "24px",
  minWidth: "64px",
  whiteSpace: "nowrap",
  borderRadius: "3px !important",
  background: theme.colors.white,
  color: theme.colors["dark-blue"],
  fontFamily: "Barlow",
  fontSize: "14px",
  textTransform: "capitalize",
  "&:hover": {
    background: theme.colors["cotton-boll"],
  },
}));
